import { axios } from '@/di-container/axios';
import {
  GetSearchAddressGateway,
  GetSearchBlueprintsGateway,
} from '@remodeling/common';

export const searchAddressGateway = () => {
  return {
    getSearchAddress: new GetSearchAddressGateway(axios),
    getSearchBlueprints: new GetSearchBlueprintsGateway(axios),
  };
};
